import * as React from 'react';

import { ConnectedSpaceInfoProvider } from '../../app/spaces/RouterHelpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../commonInfra/services/BrowserTitleService';
import { ConnectedHome } from './ConnectedHome';

export interface HomeSpaceProviderProps extends ReactDirectiveProps {
  readonly siteName: string;
}

export class HomeSpaceProvider extends React.PureComponent<HomeSpaceProviderProps> {
  private HomeSpaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'home',
    subspaceName: undefined
  };

  public render() {
    return (
      <ConnectedSpaceInfoProvider spaceInfo={this.HomeSpaceInfo}>
        <ConnectedHome {...{...this.props}}/>
      </ConnectedSpaceInfoProvider>
    );
  }

  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.home_browserTitle() });
  }
}
